import type { ViewQueryRecordNode } from '@salescore/core'
import { isUndefined } from 'effect/Predicate'

import { bindDispatcher, type StateDispatcher, type StateTransformer } from '../binder'
import { computeUndo } from './recordsHistoryHelpers'
import type { RecordsHistory } from './recordsHistoryTypes'

type Entity = RecordsHistory

const _forwardHistory = ({ records, backedChanges, changes }: Entity): Entity => {
  const currentChange = backedChanges.at(-1)
  if (currentChange?.snapshotAfterChange === undefined) {
    return { records, backedChanges, changes }
  }

  // 本当はchangesは操作せず、指し示すchangesだけを変更したいが、実装がやや面倒なので後回し
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    records: JSON.parse(currentChange.snapshotAfterChange) as ViewQueryRecordNode[],
    backedChanges: backedChanges.slice(0, -1),
    changes: [...changes, currentChange],
  }
}
const forwardHistory = (): StateTransformer<Entity> => _forwardHistory

const backHistory =
  (backCount: number): StateTransformer<Entity> =>
  ({ records, backedChanges, changes }) => {
    const currentRecordsSnapshot = JSON.stringify(records)

    const { restoredRecordsSnapshot, remainingChanges, backedChangesToAppend } = computeUndo({
      changes,
      currentRecordsSnapshot,
      backCount,
    })

    if (isUndefined(restoredRecordsSnapshot)) {
      return {
        records,
        backedChanges,
        changes,
      }
    }

    // 本当はchangesは操作せず、指し示すchangesだけを変更したいが、実装がやや面倒なので後回し
    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      records: JSON.parse(restoredRecordsSnapshot) as ViewQueryRecordNode[],
      changes: remainingChanges,
      backedChanges: [...backedChanges, ...backedChangesToAppend],
    }
  }

export const bindRecordsHistoryActions = (dispatcher: StateDispatcher<Entity>) => {
  const bind = bindDispatcher(dispatcher)
  return {
    forwardHistory: bind(forwardHistory),
    backHistory: bind(backHistory),
  }
}
